import healthInfoReducer from "./reducers";
export { default as healthInfoTypes } from "./types";
export { default as healthInfoOperations } from "./operations";
export default healthInfoReducer;
